import { internetBagimliligiQuestions } from '../data/forms';

export const calculateInternetBagimliligi = (answers) => {
  // 🛡️ ZIRH 1: Eğer cevaplar boş, tanımsız veya silinmişse sistemi çökertme, boş dön.
  if (!answers || typeof answers !== 'object' || Object.keys(answers).length === 0) {
      return { summary: "Geçersiz Veri", analysis: "Öğrenci cevapları okunamadı.", risks: [], chartData: [], isCritical: false, masterRisk: 'none', domain: 'behavioral', riskScore: 0 };
  }

  let totalScore = 0;
  let risks = [];

  Object.entries(answers).forEach(([questionId, score]) => {
    const numericScore = Number(score);
    totalScore += numericScore;

    // 3, 4 ve 5 cevaplarını riskli olarak ayırıyoruz
    if (numericScore >= 3) {
      
      // SİHİRLİ DOKUNUŞ: Soru metnini diziden bulup çekiyoruz!
      const question = internetBagimliligiQuestions.find(q => q.id === Number(questionId));
      
      const actualText = question ? question.text : `Soru ${questionId}`;

      risks.push({
        id: questionId,
        text: actualText, 
        score: numericScore,
        isCritical: numericScore >= 4 
      });
    }
  });

  // 🛡️ ZIRH 2: Eğer öğrenci testi yarıda bıraktıysa (örneğin 20 soru yerine 5 soru çözdüyse) 
  // Puanı düşük çıkacağı için sistem ona yanlışlıkla "Normal" diyebilir. 
  // Orijinal test 20 sorudur, basit bir kontrol hayat kurtarır.
  if (Object.keys(answers).length < 15) {
      return {
          riskScore: totalScore,
          masterRisk: "medium", // Eksik veri varsa şüpheli kabul et (Güvenli alan)
          isCritical: false,
          domain: "behavioral",
          totalScore, risks, 
          summary: "Eksik Doldurulmuş Test",
          riskLevel: "medium"
      };
  }

  let summaryText = "Normal Kullanım";
  if (totalScore >= 80) summaryText = "Kırmızı Alarm: İnternet Bağımlısı";
  else if (totalScore >= 50) summaryText = "Dikkat: Riskli Kullanım";

 // --- STANDART PAKETLEME (ZARF) ---
  let masterRisk = "low";
  if (totalScore >= 80) masterRisk = "high";
  else if (totalScore >= 50) masterRisk = "medium";

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: totalScore, // Zaten 100 üzerinden olduğu için direkt veriyoruz
    masterRisk: masterRisk,
    isCritical: false, // İnternet bağımlılığı çok ciddi bir "high" risktir, ama anlık hayati "critical" kriz değildir
    domain: "behavioral", // Davranışsal alan

    // 2. Mevcut Detaylı Veriler (Dashboard ve Raporlar için dokunmadık)
    totalScore, 
    risks, 
    summary: summaryText,
    riskLevel: masterRisk // Geriye dönük uyumluluk (Eski arayüz okumaya çalışırsa diye)
  };
};